import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
} from "react";
import {
  ListOrder,
  ListOrder1,
  ListOrderById,
  ListOrderMaster,
  postGeneralData,
  Updateorderpayment,
  UpdatePaymentComplete,
  updateSalesCredit,
  get_product_order_details,
  ProductReturn,
  getInvoiceNumber,
  get_order_returnlist,
} from "../../../Utility/Api";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getFormattedCurrentDate2,
  getLocalStorage,
  handleCreateAssets,
  NaviGate,
  numberToWords,
  AmountInWords,
  onReqCreatePayment,
  setLocalStorage,
  shop_id,
  isReadonlyRoute,
  company_logo,
} from "../../../Utility/function";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import Barcode from "react-barcode";
import { WarehouseContext } from "../../../Utility/UserContext";
import "./customtoogle.css";
import ThermalModal from "./modal/ThermalModal";
import { Pagination } from "../../Common/Functions";

const styles = {
  body: {
    width: "80mm",
    fontSize: "12px",
    fontFamily: "Arial, sans-serif",
    margin: "0 auto",
    padding: "5px",
    lineHeight: "1.1",
    textAlign: "center",
    background: "white",
  },
  textCenter: { textAlign: "center" },
  logo: { width: "50px", height: "auto", margin: "1px 0" },
  flexBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  bold: { fontWeight: "bold" },
  textStart: { textAlign: "left", fontSize: "11px" },
  textEnd: { textAlign: "right" },
  hr: { margin: "0px", width: "100%", opacity: 1, color: "black" },
  // hr: { border: ".8px solid black", margin: "1px 0", width: "100%" },
  table: {
    width: "100%",
    fontSize: "11px",
    borderCollapse: "collapse",
    textAlign: "center",
  },
  border: {
    border: "1px solid black",
    padding: "5px",
    marginTop: "2px",
    width: "100%",
  },
  borderbottom: { borderBottom: "1px solid black" },
  fontSize: { fontSize: "10px" },
};

const SalesList = () => {
  const { showLoader, hideLoader, UserItem, shopItem } =
    useContext(WarehouseContext);
  const [user, setuser] = useState(UserItem)
  const modalContentRef = useRef(null);
  const navigate = useNavigate();
  const ordersPerPage = 10;
  const componentRef = useRef(null);
  const [data, setdata] = useState(shopItem);
  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const [Order, setOrder] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedReturnInvoice, setSelectedReturnInvoice] = useState(null);
  const [Details, setDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [printerType, setPrinterType] = useState("1");
  const [payAmount, setPayAmount] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [uniqueId, setUniqueId] = useState("");
  const [resetDone, setResetDone] = useState(false);
  const [RemarkData, setRemarkData] = useState({});


  const [warehouseId, setWarehouseId] = useState("");
  const [empId, setEmpId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [printVisible, setPrintVisible] = useState("");
  const [printOpen, setPrintOpen] = useState(false);
  const [Paymentvalue, setPaymentvalue] = useState();
  const [pamentsModel, setpamentsModel] = useState(false);
  const [isOrderModal, setOrderModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [selectedOrderData, setSelectedOrderData] = useState();
  const [orderItems, setOrderItems] = useState([]);
  const { pathname } = useLocation();
  const [inputUniqueId, setInputUniqueId] = useState("");

  // ── Sales Return state ──────────────────────────────────────────
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnOrder, setReturnOrder] = useState(null);       // SalesMaster row
  const [returnItems, setReturnItems] = useState([]);          // order line items
  const [returnQtys, setReturnQtys] = useState({});           // { item.id: qty }
  const [returnRefundType, setReturnRefundType] = useState("bank"); // "bank" | "payable"
  const [returnReason, setReturnReason] = useState("");
  const [returnInvoiceNo, setReturnInvoiceNo] = useState("");
  const [globalReturns, setGlobalReturns] = useState([]);
  const [alreadyReturnedQtys, setAlreadyReturnedQtys] = useState({});

  const getOrderReturnedAmount = (orderId, orderMasterId) => {
    let totalReturned = 0;
    globalReturns.forEach((ret) => {
      let retData = [];
      try {
        if (ret.return_data) {
          retData = JSON.parse(ret.return_data);
        } else if (ret.invoice_number) {
          retData = JSON.parse(ret.invoice_number);
        }
      } catch (e) { }

      if (Array.isArray(retData)) {
        retData.forEach((retItem) => {
          const isMatch =
            retItem.om_id == orderMasterId ||
            retItem.unique_id === orderId ||
            (ret.unique_id && ret.unique_id.includes(orderId)) ||
            (retItem.id && retItem.id.toString().includes(orderMasterId?.toString()));

          if (isMatch) {
            const qty = parseFloat(retItem.returnqty || retItem.qty || 0);
            const price = parseFloat(retItem.price || 0);
            const amt = parseFloat(retItem.amount || (qty * price) || 0);
            totalReturned += amt;
          }
        });
      }
    });
    return totalReturned;
  };

  const getUnitPrice = (it) => {
    const qty = parseFloat(it.qty || 0);
    if (qty > 0) {
      return parseFloat(it.p_price || 0) / qty;
    }
    let fallbackPrice = 0;
    globalReturns.forEach((ret) => {
      let retData = [];
      try {
        if (ret.return_data) {
          retData = JSON.parse(ret.return_data);
        } else if (ret.invoice_number) {
          retData = JSON.parse(ret.invoice_number);
        }
      } catch (e) { }
      if (Array.isArray(retData)) {
        retData.forEach((retItem) => {
          const isMatch =
            retItem.id == it.id ||
            (retItem.p_id == it.p_id && (retItem.unique_id === returnOrder?.order_id || ret.unique_id && ret.unique_id.includes(returnOrder?.order_id)));
          if (isMatch) {
            if (retItem.price) {
              fallbackPrice = parseFloat(retItem.price);
            } else if (retItem.returnqty && retItem.amount) {
              fallbackPrice = parseFloat(retItem.amount) / parseFloat(retItem.returnqty);
            } else if (retItem.qty && retItem.price) {
              fallbackPrice = parseFloat(retItem.price);
            }
          }
        });
      }
    });
    return fallbackPrice;
  };
  // ───────────────────────────────────────────────────────────────

  const readonly = isReadonlyRoute(pathname);

  const [companyInfo, setCompanyInfo] = useState({
    name: "Company Name",
    address: "123 Business Street, City, State 12345",
    phone: "(123) 456-7890",
    email: "info@yourcompany.com"
  });

  useEffect(() => {
    if (shopItem) {
      setCompanyInfo({
        name: shopItem?.title || "",
        address: shopItem?.Address || "123 Business Street, City, State 12345",
        phone: shopItem?.phone1 || "",
        email: shopItem?.email || ""
      })
    }

  }, [shopItem])

  useEffect(() => {
    try {
      var value = getLocalStorage("PrinterType");
      if (value) {
        setPrinterType(value);
      } else {
        setPrinterType("0");
      }
    } catch (error) {
      setPrinterType("0");
    }
  }, []);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setUniqueId(inputUniqueId);
    }, 1750); // 500ms debounce

    return () => clearTimeout(delayDebounce);
  }, [inputUniqueId]);

  useEffect(() => {
    if (resetDone) {
      fetchOrders(1, "");
      setResetDone(false); // reset the flag after fetching
    }
  }, [resetDone]);

  const Handlepaymentmodel = async (item) => {
    console.log("item", item);
    setPayAmount(0);
    setCashAmount(0);
    setCardAmount(0);
    setPaymentvalue(item);
    setpamentsModel(true);
  };

  const onHandlePayCredit = async (cashAmount, cardAmount) => {
    try {
      showLoader();
      if (!Paymentvalue?.id) {
        toast.error("Invalid purchase details");
        hideLoader();
        return;
      }

      const cash = parseFloat(cashAmount || 0);
      const card = parseFloat(cardAmount || 0);
      var paydata = {
        orderID: Paymentvalue?.order_id,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: Paymentvalue.price_total,
        cash: cash,
        credit: 0,
        card: card,
        type: 2,
        mop: "0",
        complete: "1",
      };

      if (cashAmount && cardAmount) {
        paydata.cash = cashAmount;
        paydata.card = cardAmount;
        paydata.mop = "1,4";
      } else if (cashAmount) {
        paydata.cash = cashAmount;
        paydata.mop = "1";
      } else if (cardAmount) {
        paydata.card = cardAmount;
        paydata.mop = "4";
      }
      if (remainingAmount > 0) {
        paydata.credit = remainingAmount;
        paydata.mop = paydata.mop + ",2";
        paydata.complete = "0";
      }

      await onReqCreatePayment(paydata);
      try {
        const generalDataPayload = {
          type: "5",
          ref_id: Paymentvalue?.order_id,
          remarks: "Sales Entry",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0),
          is_debit: "0",
          profitloss: paydata?.complete == "1" ? Paymentvalue?.supplier_id : "",
        };
        // await postGeneralData(generalDataPayload);

        const generalDataPayload1 = {
          type: "2",
          ref_id: Paymentvalue?.order_id,
          remarks: "Bank - From sales",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0),
          is_debit: "1",
          // profitloss: paydata?.complete == "1" ? Paymentvalue?.supplier_id : "",
        };
        await postGeneralData(generalDataPayload1);

        if (paydata?.complete == "0") {
          const generalDataPayload = {
            type: "8",
            ref_id: Paymentvalue?.order_id,
            remarks: "Sales Credit",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: remainingAmount,
            is_debit: "1",
            profitloss: "",
          };
          await postGeneralData(generalDataPayload);
        } else {
          const paymentCompleted = {
            type: "8",
            shop_id: shopItem?.id || "0",
            ref_id: Paymentvalue?.order_id,
          }
          await UpdatePaymentComplete(paymentCompleted);
        }

      } catch (e) {
        console.error("General log failed:", e);
        toast.error("Failed to create general transaction log");
      }
      toast.success("Payment successfully");
      await fetchOrders();
      setpamentsModel(false);
      setCurrentPage(1);
      setPayAmount(0);
      setCashAmount(0);
      setCardAmount(0);
      hideLoader();
    } catch (error) {
      console.error("Error updating payment:", error);
      toast.error("Error processing payment. Please try again.");
      hideLoader();
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [uniqueId]);

  const fetchOrders = useCallback(
    async (pages = 1) => {
      try {
        showLoader();
        const filters = {
          from_date: fromDate,
          to_date: toDate,
          uniqueId: uniqueId,
          status: 4,
        };

        const [response, returnsRes] = await Promise.all([
          ListOrderMaster(pages, shop_id, filters),
          get_order_returnlist().catch(e => {
            console.error("Error fetching returns list inside fetchOrders:", e);
            return { data: { data: [] } };
          })
        ]);

        if (response.data && response.data.data) {
          setOrder(response.data.data);
          // setOrder(response.data.data);
          setTotalPages(response.data.pagination.total_pages);
        }
        if (returnsRes.data && returnsRes.data.data) {
          setGlobalReturns(returnsRes.data.data);
        }
        hideLoader();
      } catch (error) {
        console.error("Error fetching order data:", error);
        hideLoader();
      }
    },
    [uniqueId, fromDate, toDate, shop_id]
  );

  const fetchOrders1 = useCallback(
    async (pages = 1) => {
      try {
        showLoader();
        const filters = {
          from_date: fromDate,
          to_date: toDate,
          uniqueId: uniqueId,
          status: 4,
        };

        const response = await ListOrderMaster(pages, shop_id, filters);
        if (response.data && response.data.data) {
          // Filter orders with status 4 on client side
          const filteredOrders = response.data.data.filter(order => order.status === 4);

          setOrder(filteredOrders);
          setTotalPages(response.data.pagination.total_pages);
          hideLoader();
        }
      } catch (error) {
        console.error("Error fetching order data:", error);
        hideLoader();
      }
    },
    [uniqueId, fromDate, toDate, shop_id]
  );

  const handleFilter = (e) => {
    e.preventDefault();
    if (fromDate && !toDate) {
      toast.error("Please select To date ");
      return;
    }
    if (toDate && !fromDate) {
      toast.error("Please select From Date");
      return;
    }
    fetchOrders();
  };

  const resetFilter = () => {
    setFromDate("");
    setToDate("");
    setUniqueId("");
    setResetDone(true);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchOrders(pageNumber);
  };

  const handleGetpayment = async (state) => {
    try {
      showLoader();
      setOrderModal(true);
      setSelectedOrder([]);
      setOrderItems([]);
      setSelectedOrderData(state);
      const [paymentRes, itemsRes] = await Promise.all([
        ListOrderById(state.order_id),
        get_product_order_details({ om_id: state.id })
      ]);
      if (paymentRes.data && paymentRes.data.payment) {
        setSelectedOrder(paymentRes.data.payment);
      } else {
        setSelectedOrder([]);
      }
      if (itemsRes.data && itemsRes.data.data) {
        setOrderItems(itemsRes.data.data);
      } else {
        setOrderItems([]);
      }
      hideLoader();
    } catch (error) {
      hideLoader();
      setSelectedOrder([]);
      setOrderItems([]);
      console.error("Error fetching order details:", error);
    }
  };

  const handleGet = async (state) => {
    try {
      setDetails(state);
      const response = await ListOrder1(state.id);
      if (response.data && response.data.data) {
        setSelectedInvoice(response.data.data);
        console.log("response.data.data", response.data.data);
      }
      if (response.data && response.data.return_sale) {
        setSelectedReturnInvoice(response.data.return_sale);
      }
      if (response.data && response.data.remark) {
        setRemarkData(response.data.remark);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
    setShowModal(true);
  };

  const handlePrint = async () => {
    setPrintVisible("d-none");
    setTimeout(async () => {
      const content = modalContentRef.current; // Reference to modal content

      if (!content) {
        console.error("Modal content not found for printing");
        return;
      }

      try {
        const canvas = await html2canvas(content, { scale: 3 });
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = pdf.internal.pageSize.getWidth(); // A4 width
        const pdfHeight = pdf.internal.pageSize.getHeight(); // A4 height

        const imgWidth = 200;
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Keep aspect ratio

        // Center the image in PDF
        const xOffset = (pdfWidth - imgWidth) / 2;
        const yOffset = (pdfHeight - imgHeight) / 2;

        pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);

        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);

        const printWindow = window.open(pdfUrl, "_blank");

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print();
          };
        } else {
          console.error("Failed to open the print window");
        }

        URL.revokeObjectURL(pdfUrl);
        setTimeout(() => {
          setPrintVisible("");
        }, 1000);
      } catch (error) {
        setPrintVisible("");
        console.error("Failed to generate or print the PDF:", error);
      }
    }, 10);
  };

  const handlePrint1 = async () => {
    const content = componentRef.current; // Reference to modal content

    if (!content) {
      console.error("Modal content not found for printing");
      return;
    }

    try {
      const canvas = await html2canvas(content, { scale: 3 });
      const imgData = canvas.toDataURL("image/png");

      // Calculate required height dynamically based on content
      const contentHeightMm = (canvas.height * 80) / canvas.width; // Convert based on width
      const pageHeight = 210; // Single page height in mm
      const totalPages = Math.ceil(contentHeightMm / pageHeight); // Number of pages needed

      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [80, contentHeightMm], // Set dynamic height
      });

      let yOffset = 5; // Small margin

      // for (let i = 0; i < totalPages; i++) {
      //   const yPosition = -(i * pageHeight); // Crop position for each page
      //   pdf.addImage(imgData, "PNG", 1, yOffset, 78, contentHeightMm, undefined, 'FAST');

      //   if (i < totalPages - 1) pdf.addPage();
      // }
      pdf.addImage(
        imgData,
        "PNG",
        1,
        yOffset,
        78,
        contentHeightMm,
        undefined,
        "FAST"
      );
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const printWindow = window.open(pdfUrl, "_blank");

      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      } else {
        console.error("Failed to open the print window");
      }

      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error("Error generating the receipt PDF:", error);
    }
  };

  const handleSelectPrinter = (type) => {
    setLocalStorage("PrinterType", type);
    setPrinterType(type);
    setPrintOpen(false);
  };

  const [cashAmount, setCashAmount] = useState("");
  const [cardAmount, setCardAmount] = useState("");

  const dueAmount = parseFloat(Paymentvalue?.remaining || 0);
  const totalPayment =
    parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0);
  const remainingAmount = dueAmount - totalPayment;

  const handleCashChange1 = (e) => {
    let value = parseFloat(e.target.value || 0);
    if (value + parseFloat(cardAmount || 0) > dueAmount) return;
    setCashAmount(value);
  };

  const handleCardChange1 = (e) => {
    let value = parseFloat(e.target.value || 0);
    if (value + parseFloat(cashAmount || 0) > dueAmount) return;
    setCardAmount(value);
  };

  const handleCashChange = (e) => {
    let value = e.target.value;

    // allow empty (user erased all digits)
    if (value === "") {
      setCashAmount("");
      return;
    }

    // allow only numbers
    if (!/^\d+$/.test(value)) return;

    const numericValue = parseFloat(value);

    // prevent overpayment
    if (numericValue + parseFloat(cardAmount || 0) > dueAmount) return;

    setCashAmount(value);
  };


  const handleCardChange = (e) => {
    let value = e.target.value;

    if (value === "") {
      setCardAmount("");
      return;
    }

    if (!/^\d+$/.test(value)) return;

    const numericValue = parseFloat(value);

    if (numericValue + parseFloat(cashAmount || 0) > dueAmount) return;

    setCardAmount(value);
  };


  const paidAmount = selectedOrder
    ?.filter((item) => item.mop != "2")
    .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

  const handleToggle = (e) => {
    if (printerType == "0") {
      handleSelectPrinter("1");
    } else {
      handleSelectPrinter("0");
    }
  };

  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  // ── Sales Return Handlers ────────────────────────────────────────
  const handleOpenReturn = async (order) => {
    try {
      showLoader();
      setReturnOrder(order);
      setReturnQtys({});
      setReturnReason("");
      setReturnRefundType("bank");

      // Fetch invoice number for the return
      const invRes = await getInvoiceNumber(4);
      if (invRes.data?.invoice_no) setReturnInvoiceNo(invRes.data.invoice_no);

      // Fetch order line items
      const itemsRes = await get_product_order_details({ om_id: order.id });
      const items = itemsRes?.data?.data || [];
      setReturnItems(items);

      // Fetch returns list to calculate already returned quantities
      const returnsRes = await get_order_returnlist().catch(e => {
        console.error("Error fetching returns:", e);
        return { data: { data: [] } };
      });
      const returnsList = returnsRes?.data?.data || [];
      setGlobalReturns(returnsList);

      const returnedCounts = {};
      items.forEach((it) => {
        let totalReturned = 0;
        returnsList.forEach((ret) => {
          let retData = [];
          try {
            if (ret.return_data) {
              retData = JSON.parse(ret.return_data);
            } else if (ret.invoice_number) {
              retData = JSON.parse(ret.invoice_number);
            }
          } catch (e) { }

          if (Array.isArray(retData)) {
            retData.forEach((retItem) => {
              const isMatch =
                retItem.id == it.id ||
                (retItem.p_id == it.p_id && (retItem.unique_id === order.order_id || ret.unique_id && ret.unique_id.includes(order.order_id)));

              if (isMatch) {
                totalReturned += parseFloat(retItem.returnqty || retItem.qty || 0);
              }
            });
          }
        });
        returnedCounts[it.id] = totalReturned;
      });
      setAlreadyReturnedQtys(returnedCounts);

      // Pre-fill qty = 0 for each item
      const initial = {};
      items.forEach((it) => { initial[it.id] = 0; });
      setReturnQtys(initial);

      setShowReturnModal(true);
    } catch (err) {
      console.error("Error opening return:", err);
      toast.error("Failed to load order items");
    } finally {
      hideLoader();
    }
  };

  const handleReturnQtyChange = (itemId, value, maxQty) => {
    let v = parseInt(value, 10);
    if (isNaN(v) || v < 0) v = 0;
    if (v > maxQty) v = maxQty;
    setReturnQtys((prev) => ({ ...prev, [itemId]: v }));
  };

  const calcReturnFinancials = () => {
    let totalReturn = 0;
    returnItems.forEach((it) => {
      const qty = returnQtys[it.id] || 0;
      // const unitPrice = parseFloat(it.qty || 1) > 0 ? (parseFloat(it.p_price || 0) / parseFloat(it.qty || 1)) : 0;
      const unitPrice = getUnitPrice(it);
      totalReturn += qty * unitPrice;
    });

    // Calculate correct credit balance of this order before this return
    const returnedAmt = getOrderReturnedAmount(returnOrder?.order_id, returnOrder?.id);
    const creditBalance = Math.max(0, parseFloat(returnOrder?.remaining || 0) - returnedAmt);

    const creditAdjust = Math.min(totalReturn, creditBalance);
    const refundAmount = Math.max(0, totalReturn - creditAdjust);
    const newCredit = Math.max(0, creditBalance - creditAdjust);
    return { totalReturn, creditAdjust, refundAmount, newCredit };
  };

  const handleSubmitReturn = async () => {
    const selectedItems = returnItems.filter((it) => (returnQtys[it.id] || 0) > 0);
    if (selectedItems.length === 0) {
      toast.error("Please select at least one item to return");
      return;
    }

    try {
      showLoader();
      const fin = calcReturnFinancials();
      const currentDate = getFormattedCurrentDate2();
      const shopId = shopItem?.id || shopItem?.shop_id || "0";

      // Build payload for each returned item
      const returnPayloads = selectedItems.map((it) => {
        const qty = returnQtys[it.id];
        // const unitPrice = parseFloat(it.qty || 1) > 0 ? (parseFloat(it.p_price || 0) / parseFloat(it.qty || 1)) : 0;
        const unitPrice = getUnitPrice(it);
        const returnAmt = qty * unitPrice;
        return {
          id: it.id,
          om_id: it.om_id,
          p_id: it.p_id,
          returnqty: qty,
          return_serial_number: "[]",
          serial_number: "[]",
          unique_id: it.order_id || returnOrder?.order_id,
          supplier_id: returnOrder?.customer_id,
          customer_name: returnOrder?.customer_name,
          user_id: user?.user_id,
          shop_id: shopId,
          amount: returnAmt.toFixed(2),
          credit_adjustment: "0",
        };
      });

      // Call backend product_return
      await ProductReturn({
        serial_number: JSON.stringify([]),
        invoice_number: JSON.stringify(selectedItems.map((it) => {
          // const unitPrice = parseFloat(it.qty || 1) > 0 ? (parseFloat(it.p_price || 0) / parseFloat(it.qty || 1)) : 0;
          const unitPrice = getUnitPrice(it);
          return {
            unique_id: it.order_id || returnOrder?.order_id,
            product_name: it.product_title || it.product_name || `Product #${it.p_id}`,
            qty: returnQtys[it.id],
            price: unitPrice.toFixed(2),
          };
        })),
        amount: fin.refundAmount.toFixed(2),
        credit_adjustment: fin.creditAdjust.toFixed(2),
        remaining: returnRefundType === "payable" ? fin.refundAmount.toFixed(2) : "0",
        sales_update: JSON.stringify(selectedItems.map((it) => ({
          id: it.id,
          serial_number: [],
        }))),
        unique_id: returnInvoiceNo,
        user_id: user?.user_id || "",
        shop_id: shopId,
        type: "0",
        return_data: JSON.stringify(returnPayloads),
        status: returnRefundType === "payable" ? 1 : 0,
        returnqty: selectedItems.reduce((s, it) => s + (returnQtys[it.id] || 0), 0),
        remarks: returnReason || `Sales Return - ${returnOrder?.order_id}`,
      });

      // ── GL Entries ────────────────────────────────────────────────
      const totalReturnAmt = fin.totalReturn;

      // 1. Reverse Sales Revenue (type=5 debit)
      await postGeneralData({
        type: "5",
        ref_id: returnInvoiceNo,
        remarks: `Sales Return - ${returnOrder?.order_id}${returnReason ? ": " + returnReason : ""}`,
        date: currentDate,
        created_by: user?.user_id,
        shop_id: shopId,
        amount: totalReturnAmt.toFixed(2),
        is_debit: "1",
      });

      // 2. Restore Inventory (type=3.1 debit — Finished Goods back in stock)
      const totalCogs = selectedItems.reduce((s, it) => {
        return s + (returnQtys[it.id] || 0) * parseFloat(it.mfg_price || it.p_price || 0);
      }, 0);
      if (totalCogs > 0) {
        await postGeneralData({
          type: "3.1",
          ref_id: returnInvoiceNo,
          remarks: `Inventory Restored - Sales Return ${returnOrder?.order_id}`,
          date: currentDate,
          created_by: user?.user_id,
          shop_id: shopId,
          amount: totalCogs.toFixed(2),
          is_debit: "1",
        });
        // Reverse COGS (type=4 credit)
        await postGeneralData({
          type: "4",
          ref_id: returnInvoiceNo,
          remarks: `COGS Reversal - Sales Return ${returnOrder?.order_id}`,
          date: currentDate,
          created_by: user?.user_id,
          shop_id: shopId,
          amount: totalCogs.toFixed(2),
          is_debit: "0",
        });
      }

      // 3a. If there's credit to adjust (customer owed us money → reduce their debt)
      if (fin.creditAdjust > 0) {
        await postGeneralData({
          type: "8",
          ref_id: returnInvoiceNo,
          remarks: `Credit Adjusted - Sales Return ${returnOrder?.order_id}`,
          date: currentDate,
          created_by: user?.user_id,
          shop_id: shopId,
          amount: fin.creditAdjust.toFixed(2),
          is_debit: "0",
        });
      }

      // 3b. Handle excess refund
      if (fin.refundAmount > 0) {
        if (returnRefundType === "bank") {
          // Deduct from bank (type=2 credit = money out)
          await postGeneralData({
            type: "2",
            ref_id: returnInvoiceNo,
            remarks: `Bank - Sales Return Refund ${returnOrder?.order_id}`,
            date: currentDate,
            created_by: user?.user_id,
            shop_id: shopId,
            amount: fin.refundAmount.toFixed(2),
            is_debit: "0",
          });
        } else {
          // Keep as customer payable (type=12 credit = payable to customer)
          await postGeneralData({
            type: "12",
            ref_id: returnInvoiceNo,
            remarks: `Customer Payable - Sales Return ${returnOrder?.order_id}`,
            date: currentDate,
            created_by: user?.user_id,
            shop_id: shopId,
            amount: fin.refundAmount.toFixed(2),
            is_debit: "0",
          });
        }
      }

      toast.success(
        `Return processed! ${fin.refundAmount > 0
          ? returnRefundType === "bank"
            ? `₹${fin.refundAmount.toFixed(2)} refunded to bank.`
            : `₹${fin.refundAmount.toFixed(2)} recorded as customer payable.`
          : "Credit adjusted."
        }`
      );
      setShowReturnModal(false);
      fetchOrders(currentPage);
    } catch (err) {
      console.error("Return error:", err);
      toast.error(err?.response?.data?.message || "Failed to process return");
    } finally {
      hideLoader();
    }
  };
  // ────────────────────────────────────────────────────────────────

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded-2xl border border-slate-100 shadow-sm">
          <div className="text-start">
            <h3 className="mb-1 fw-bold text-slate-800 tracking-tight" style={{ fontSize: "24px" }}>Sales List</h3>
            <p className="text-sm text-slate-500 mb-0 font-medium">Record and manage customer sales invoices</p>
          </div>
        </div>

        {/* Filters Section */}
        <form onSubmit={handleFilter} className="row g-3 mb-3 d-none ">
          <div className="col-md-2 ">
            <label>From Date:</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="col-md-2  align-items-end ">
            <label>To Date:</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="col-md-2 ">
            <label>Unique ID:</label>
            <input
              type="text"
              className="form-control"
              value={inputUniqueId}
              onChange={(e) => setInputUniqueId(e.target.value)}
            />
          </div>
          <div className="col-6 col-md-2 mb-2 mb-md-0 d-flex flex-column align-items-end gap-1 ms-auto">
            <button
              type="submit"
              className="btn btn-primary btn-sm px-2 py-1 w-auto"
              style={{ fontSize: "0.75rem", minWidth: "100px" }}
            >
              Filter
            </button>
            <button
              type="button"
              onClick={resetFilter}
              className="btn btn-secondary btn-sm px-2 py-1 w-auto"
              style={{ fontSize: "0.75rem", minWidth: "100px" }}
            >
              Reset
            </button>
          </div>
        </form>

        {/* Sales Table */}
        <div className="card border-0 shadow-sm rounded-2xl">
          <div className="card-body p-4">
            <div className="table-responsive">
              <table
                className="table table-hover table-align-middle text-center mb-4"
                style={{ width: "100%", fontFamily: "Poppins" }}
              >
                <thead className="table-light">
                  <tr>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">#</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Unique ID</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Customer</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Total Price (INR)</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Action</th>
                    {!readonly && <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider"></th>}
                  </tr>
                </thead>
                <tbody>
                  {Order.map((item, index) => (
                    <tr key={index} className="align-middle border-bottom border-slate-100">
                      <td className="text-sm font-semibold text-slate-700 py-3">{(currentPage - 1) * ordersPerPage + index + 1}</td>
                      <td className="text-sm font-semibold text-slate-700">{item.order_id}</td>
                      <td className="text-sm text-slate-600">{item.customer_name}</td>
                      <td className="text-sm text-slate-600">{new Date(item.date_time).toLocaleString()}</td>
                      <td className="text-sm font-semibold text-slate-700">{item.overall_price}</td>
                      <td className="text-sm text-slate-600">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          <img
                            src="/assets/images/icons/view.png"
                            onClick={() => handleGetpayment(item)}
                            style={{ height: "16px", cursor: "pointer" }}
                            alt="View"
                          />
                          {!readonly && (
                            <button
                              className="btn btn-danger btn-sm py-0.5 px-2"
                              style={{ fontSize: "11px", borderRadius: "4px" }}
                              onClick={() => handleOpenReturn(item)}
                              title="Process Return"
                            >
                              Return
                            </button>
                          )}
                        </div>
                      </td>
                      {!readonly && (() => {
                        const returnedAmt = getOrderReturnedAmount(item.order_id, item.id);
                        const remainingBal = Math.max(0, parseFloat(item?.remaining || 0) - returnedAmt);
                        return (
                          <td className="text-sm text-slate-600">
                            <div className="d-flex justify-content-center">
                              {(item?.purchase_unit == 2 && remainingBal > 0) ? (
                                <button
                                  className="btn btn-warning btn-sm w-50"
                                  onClick={() => {
                                    Handlepaymentmodel({ ...item, remaining: remainingBal });
                                  }}
                                >
                                  Pay
                                </button>
                              ) : (
                                <button className="btn btn-success btn-sm w-50" disabled>
                                  {returnedAmt > 0 && remainingBal === 0 ? "Returned" : "Paid"}
                                </button>
                              )}
                            </div>
                          </td>
                        );
                      })()}
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>

        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          tabIndex={-1}
          role="dialog"
          style={{ display: showModal ? "block" : "none" }}
          aria-hidden={!showModal}
        >
          <div
            className={`modal-dialog ${printerType == "1" ? "modal-sm" : "modal-lg"
              }`}
            role="document"
          >
            <div className="modal-content" ref={modalContentRef}>
              <div className="modal-header border-0 pb-0 mb-1">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              {printerType == "1" && (
                <>
                  <ThermalModal
                    ref={componentRef}
                    InvoiceDetail={Details}
                    Products={selectedInvoice}
                    ReturnItem={selectedReturnInvoice}
                    Payment={selectedOrder}
                    paidAmount={paidAmount}
                    companyInfo={companyInfo}
                  />
                </>
              )}

              {printerType == "0" && (
                <>
                  <div className="d-flex justify-content-end mt-2 mx-4">
                    <div className="form-check form-check-inline mx-1">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="language"
                        id="english"
                        value="english"
                        checked={selectedLanguage === "english"}
                        onChange={() => setSelectedLanguage("english")}
                      />
                      <label className="form-check-label" htmlFor="english">
                        English
                      </label>
                    </div>
                    <div className="form-check form-check-inline ">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="language"
                        id="arabic"
                        value="arabic"
                        checked={selectedLanguage === "arabic"}
                        onChange={() => setSelectedLanguage("arabic")}
                      />
                      <label className="form-check-label" htmlFor="arabic">
                        العربية
                      </label>
                    </div>
                  </div>

                  <div className="row mx-3 mt-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="col-md-1">
                        <img
                          src={company_logo || "assets/images/tech_logo.webp"}
                          alt="Left Logo"
                          style={{ maxHeight: "38px" }}
                        />
                      </div>
                      {/* <div className="mt-0 mb-2">
                        <img
                          src="assets/images/arabic.jpg"
                          alt="Left Logo"
                          style={{ maxHeight: "38px" }}
                        />
                      </div> */}
                    </div>
                    <div className="col-12 text-center">
                      <p className="fw-bold font-14 mb-0">
                        {companyInfo?.address}
                      </p>
                      <p className="fw-medium font-13 mb-0">
                        Mobile: {companyInfo?.phone} |
                        Email: {companyInfo?.email}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col text-center">
                      <h3
                        className="fw-bold mt-2"
                        style={{ textDecoration: "underline" }}
                      ></h3>
                      <h3 className="fw-bold">
                        {" "}
                        {selectedLanguage === "arabic" ? "فاتورة" : "Invoice"}
                      </h3>
                    </div>
                  </div>

                  <div className="row border-top border-bottom pt-3 mx-3 pb-2">
                    <div className="col-6">
                      <div
                        className="p-2"
                        style={{
                          border: ".8px solid #dee2e6",
                          minHeight: 150,
                        }}
                      >
                        <h6 className="fw-bold">
                          {selectedLanguage === "arabic"
                            ? "تفاصيل العميل:"
                            : "Customer Details:"}
                        </h6>
                        <div className="d-flex justify-content-between">
                          <p className="fw-semibold font-13 mb-1">
                            {selectedLanguage === "arabic" ? "الاسم:" : "Name:"}
                          </p>
                          <p
                            className="fw-bold font-13 mb-1"
                          // style={{ textDecoration: "underline" }}
                          >
                            {Details?.customer_name}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p className="fw-semibold font-13 mb-1">
                            {selectedLanguage === "arabic"
                              ? "البريد الإلكتروني:"
                              : "Email:"}
                          </p>
                          <p
                            className="fw-bold font-13 mb-1"
                          // style={{ textDecoration: "underline" }}
                          >
                            {Details?.customer_email}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p className="fw-semibold font-13 mb-1">
                            {selectedLanguage === "arabic"
                              ? "العنوان:"
                              : "Address:"}
                          </p>
                          <p
                            className="fw-bold font-13 mb-1"
                          // style={{ textDecoration: "underline" }}
                          >
                            {Details?.additional_details}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p className="fw-semibold font-13 mb-1">
                            {selectedLanguage === "arabic"
                              ? "الهاتف:"
                              : "Phone:"}
                          </p>
                          <p
                            className="fw-bold font-13 mb-1"
                          // style={{ textDecoration: "underline" }}
                          >
                            {Details?.customer_phone}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <table className="table table-bordered text-center align-middle m-0">
                        <tbody>
                          <tr className="hight-header">
                            <td className="text-start fw-bold">
                              {selectedLanguage === "arabic"
                                ? "رقم الفاتورة:"
                                : "Inv No:"}
                              {Details.order_id}
                            </td>
                            <td className="text-start fw-bold">
                              {selectedLanguage === "arabic"
                                ? "التاريخ:"
                                : "Date:"}{" "}
                              {Details.create_date?.split('T')[0]}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="table table-bordered text-center align-middle">
                        <tbody>
                          <tr>
                            <td className="text-start d-flex flex-row">
                              <p
                                className="fw-bold text-start mb-0"
                                style={{ width: "40%" }}
                              >
                                {selectedLanguage === "arabic"
                                  ? "رقم الطلب:"
                                  : "L.P.O No:"}
                              </p>
                              <p
                                className="text-start mb-0 fw-semibold"
                                style={{ width: "60%" }}
                              >
                                {Details?.lpo_no}{" "}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-start d-flex flex-row">
                              <p
                                className="fw-bold text-start mb-0"
                                style={{ width: "40%" }}
                              >
                                {selectedLanguage === "arabic"
                                  ? "البائع:"
                                  : "Sales Person:"}
                              </p>
                              <p
                                className="text-start mb-0 fw-semibold"
                                style={{ width: "60%" }}
                              >
                                {Details?.user_name}{" "}
                              </p>
                            </td>
                          </tr>
                          {/* <tr>
                            <td className="text-start d-flex flex-row">
                              <p
                                className="fw-bold text-start mb-0"
                                style={{ width: "40%" }}
                              >
                                {selectedLanguage === "arabic"
                                  ? "شروط الدفع:"
                                  : "Payment Terms:"}
                              </p>
                              <p
                                className="text-start mb-0"
                                style={{ width: "60%" }}
                              >
                                {Details.purchase_unit == 1 ? "Cash" : "Credit"}
                              </p>
                            </td>
                          </tr> */}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row mt-4 mx-4">
                    <div
                      className="col-md-12"
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 90%), rgba(255, 255, 255, 90%)), url(assets/images/tech_logo.webp) no-repeat center center / cover`,
                        backgroundSize: "60%",
                        backgroundPosition: "center",
                      }}
                    >
                      <div className="table-responsive">
                        <table className=" border table-sm table-bordered w-100">
                          <thead className="table-light">
                            <tr className="bg-transparent">
                              <th className="bg-transparent">
                                <span>
                                  {selectedLanguage === "arabic"
                                    ? "الرقم"
                                    : "SL No."}
                                </span>
                              </th>
                              <th className="bg-transparent">
                                <span>
                                  {selectedLanguage === "arabic"
                                    ? "التفاصيل"
                                    : "Particulars"}
                                </span>
                              </th>

                              <th className="bg-transparent">
                                <span>
                                  {selectedLanguage === "arabic"
                                    ? "الكمية"
                                    : " Pkg Qty"}
                                </span>
                              </th>
                              {/* <th className="bg-transparent">
                                <span>
                                  {selectedLanguage === "arabic"
                                    ? "عودة الكمية"
                                    : "Return Qty"}
                                </span>
                              </th> */}
                              <th className="bg-transparent">
                                <span>
                                  {selectedLanguage === "arabic"
                                    ? "سعر الوحدة"
                                    : "Unit Price"}{" "}
                                </span>
                              </th>
                              <th className="bg-transparent">
                                <span>
                                  {selectedLanguage === "arabic"
                                    ? "الخصم"
                                    : "Offer"}
                                </span>
                              </th>
                              {/* <th className="bg-transparent">
                                <span>
                                  {selectedLanguage === "arabic"
                                    ? "Warranty"
                                    : "Warranty"}
                                </span>
                              </th> */}
                              <th className="bg-transparent" colSpan={2}>
                                <span>
                                  {selectedLanguage === "arabic"
                                    ? "المبلغ الإجمالي"
                                    : "Total Amount"}{" "}
                                </span>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {Array.isArray(selectedInvoice) &&
                              selectedInvoice?.map((item, index) => {
                                const isExpanded = expandedIndex === index;
                                const serials = JSON.parse(
                                  item.serial_number || "[]"
                                );
                                const unitPrice = Number(item.sales_price); // per unit
                                const qty = Number(
                                  item.is_box ? item.boxqty : item.qty
                                );

                                return (
                                  <React.Fragment key={index}>
                                    <tr className="bg-transparent">
                                      <td className="bg-transparent">
                                        {index + 1}
                                      </td>
                                      <td
                                        className="fw-semibold"
                                        style={{
                                          whiteSpace: "normal",
                                          maxWidth: "240px",
                                        }}
                                      >
                                        {item.product_name}{" ("}{item.p_weight}{item.pbox_unit}{")"}
                                        {/* {serials && serials.length > 0 ? (
                                          <div
                                            style={{
                                              fontSize: "0.85rem",
                                              color: "#6c757d",
                                            }}
                                          >
                                            {serials.map((i) => i.serial_number).join(", ")}
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              fontSize: "0.80rem",
                                              color: "#ff0000",
                                              opacity: 0.55,
                                            }}
                                          >
                                            No serial Number Available
                                          </div>
                                        )} */}
                                      </td>
                                      <td className="fw-semibold">
                                        {item?.is_box == 1
                                          ? `${item.boxqty} (x${parseInt(item.qty) ||
                                          0 / parseInt(item.boxqty) ||
                                          0
                                          })`
                                          : item.qty}
                                      </td>
                                      {/* <td className="fw-semibold">
                                       {item.return_qty}
                                      </td> */}
                                      <td className="fw-semibold">
                                        {(item.p_price) / (item.qty)}
                                      </td>

                                      <td className="fw-semibold">
                                        {/* {item.is_free || 0}{" "} */}
                                        {item.is_free == "1" ? "Offer Product" : "Normal sale"}
                                      </td>
                                      {/* <td className="fw-semibold">
                                        {item.warranty || "-"}
                                      </td> */}
                                      <td
                                        className="fw-semibold"
                                        colSpan={2}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {item.is_free == "1" ? "0" : Number(item.p_price).toFixed(3)}{" "}
                                      </td>
                                    </tr>

                                    {/* {
                                    Array.from({ length: qty }).map((_, i) => (
                                      <tr key={`expanded-${index}-${i}`} className="bg-light text-muted">
                                        <td className="text-muted bg-light"></td>
                                        <td className="text-muted bg-light">{item.product_name} - Serial No: {serials[i] || ''}</td>
                                        <td className="text-muted bg-light">1</td>
                                        <td className="text-muted bg-light">{unitPrice}</td>
                                        <td className="fw-semibold">
                                          {item.discount || 0}{" "}
                                          {item.discount_type == "1" ? "%" : "RO"}
                                        </td>


                                        <td className="text-muted bg-light">{unitPrice}</td>
                                      </tr>
                                    ))} */}
                                  </React.Fragment>
                                );
                              })}
                            {/* {Array.isArray(selectedInvoice) &&
                              selectedInvoice.map((item, index) => (
                                <tr>
                                  <td className="fw-semibold">{index + 1}</td>
                                  <td className="fw-semibold" style={{whiteSpace:'normal'}}>{item.product_name}</td>
                                  <td className="fw-semibold">
                                    {item?.is_box == 1
                                      ? `${item.boxqty} (x${parseInt(item.qty) ||
                                      0 / parseInt(item.boxqty) ||
                                      0
                                      })`
                                      : item.qty}
                                  </td>
                                  <td className="fw-semibold">{item.sales_price}</td>
                                  <td className="fw-semibold">
                                    {item.discount || 0}{" "}
                                    {item.discount_type == "1" ? "%" : "RO"}
                                  </td>
                                  <td className="fw-semibold">{item.amount_per_price}</td>
                                </tr>
                              ))} */}
                            {selectedReturnInvoice?.length > 0 && (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  <strong>
                                    {selectedLanguage === "arabic"
                                      ? "إرجاع المنتجات"
                                      : "Return Products"}
                                  </strong>
                                </td>
                              </tr>
                            )}
                            {Array.isArray(selectedReturnInvoice) &&
                              selectedReturnInvoice.map((item, index) => (
                                <tr key={`additional-product-${index}`}>
                                  <td className='text-semibold'>{index + 1}</td>
                                  <td className='text-semibold'>
                                    {item?.product_name || "N/A"}
                                    {item?.returnSerialNumber && JSON.parse(item?.returnSerialNumber).length > 0 &&
                                      <div
                                        style={{
                                          fontSize: "0.85rem",
                                          color: "#6c757d",
                                        }}
                                      >
                                        {JSON.parse(item?.returnSerialNumber).map((i) => i.serial_number).join(", ")}
                                      </div>}
                                  </td>
                                  <td className='text-semibold'>{item?.returnQty || "0"}</td>
                                  <td className='text-semibold'>{item?.sales_price}</td>
                                  <td className='text-semibold'>
                                    {/* {(((parseFloat(item.discount) || 0) / Number(item.qty)) * Number(item?.returnQty)).toFixed(2)}{" "} */}
                                    {item.is_free == "0" ? "Normal sale" : "Offer Product"}
                                  </td>
                                  <td className='text-semibold'>{item?.warranty || "-"}</td>
                                  <td colSpan={2}>{"- " + item?.returnAmount}</td>
                                </tr>
                              ))}
                          </tbody>

                          <tfoot>
                            <tr>
                              <br />
                            </tr>

                            <tr>
                              <td className="bg-transparent fw-bold text-end" colSpan={6}>
                                {selectedLanguage === "arabic"
                                  ? "الإجمالي"
                                  : "Total"}
                              </td>
                              <td className="bg-transparent fw-semibold">
                                {
                                  selectedInvoice
                                    ?.reduce((acc, item) => {
                                      if (item?.is_free === "1") return acc; // skip free items
                                      return acc + (parseFloat(item?.p_price) || 0);
                                    }, 0)
                                    .toFixed(3)
                                }

                              </td>
                            </tr>

                            {/* <tr className="d-none">
                              <td className="bg-transparent fw-bold text-end" colSpan={7}>
                                {selectedLanguage === "arabic"
                                  ? "الخصم"
                                  : "Discount"}
                              </td>
                              <td className="bg-transparent fw-semibold">
                                {Details?.discount}
                              </td>
                            </tr> */}

                            {/* <tr>
                              <td className="bg-transparent fw-bold text-end" colSpan={7}>
                                {selectedLanguage === "arabic"
                                  ? "تخفيض"
                                  : "Discount (-)"}
                              </td>
                              <td className="bg-transparent fw-semibold">
                                {Details?.discount}
                              </td>
                            </tr> */}
                            {/* <tr>
                              <td className="bg-transparent fw-bold text-end" colSpan={7}>
                                {selectedLanguage === "arabic"
                                  ? "الضريبة"
                                  : "Tax (+)"}
                              </td>
                              <td className="bg-transparent fw-semibold">
                                {(
                                  (selectedInvoice?.reduce(
                                    (acc, item) =>
                                      acc +
                                      (parseFloat(item.amount_per_price) || 0),
                                    0
                                  ) /
                                    100) *
                                  Details?.vat || 0
                                ).toFixed(3)}
                              </td>
                            </tr> */}

                            {/* <tr>
                              <td className="bg-transparent fw-bold text-end" colSpan={7}>
                                {selectedLanguage === "arabic"
                                  ? "إرجاع"
                                  : "Return"}
                              </td>
                              <td className="bg-transparent text-danger fw-semibold">
                                - {selectedReturnInvoice?.reduce((acc, item) => acc + Number(item?.returnAmount || 0), 0)}
                              </td>
                            </tr> */}

                            {/* <tr>
                              <td className="bg-transparent fw-bold text-end" colSpan={6}>
                                {selectedLanguage === "arabic"
                                  ? "الإجمالي"
                                  : "Grand Total"}
                              </td>
                              <td className="fw-semibold">
                                {(
                                  parseFloat(Details?.p_price || 0) -
                                  selectedReturnInvoice?.reduce(
                                    (acc, item) =>
                                      acc +
                                      (parseFloat(item.p_price) || 0),
                                    0
                                  )
                                ).toFixed(3)}
                                // {parseFloat(Details?.total || 0).toFixed(3)}
                              </td>
                            </tr> */}

                            {Details.purchase_unit != 1 && (
                              <tr>
                                <td
                                  colSpan={6}
                                  className="text-center fw-semibold"
                                >
                                  Payment History
                                </td>
                              </tr>
                            )}

                            {Details.purchase_unit != 1 &&
                              selectedOrder
                                ?.filter((item) => item.mop != "2")
                                ?.map((item, index) => (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      className="text-end fw-bold px-2"
                                    >
                                      {item.date}
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="text-end fw-bold px-2"
                                    >
                                      {item.mop == "1"
                                        ? "Cash"
                                        : item.mop == "4"
                                          ? "Card"
                                          : ""}
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="text-center fw-semibold"
                                    >
                                      {parseFloat(item.amount || 0).toFixed(3)}
                                    </td>
                                  </tr>
                                ))}

                            {Details.purchase_unit != 1 && (
                              <tr>
                                <td
                                  colSpan={6}
                                  className="text-end fw-bold px-2"
                                >
                                  {"Remaining Balance"}
                                </td>
                                <td
                                  colSpan={1}
                                  className="text-center text-danger fw-semibold"
                                >
                                  {(
                                    parseFloat(Details?.overall_price || 0) -
                                    // -
                                    // selectedReturnInvoice?.reduce(
                                    //   (acc, item) =>
                                    //     acc +
                                    //     (parseFloat(item.amount_per_price) || 0),
                                    //   0
                                    // )
                                    parseFloat(paidAmount || 0)
                                  ).toFixed(3)}
                                </td>
                              </tr>
                            )}

                            <tr>
                              <td colSpan={6} className="text-start text-wrap">
                                <p className="my-2">
                                  <strong>
                                    {selectedLanguage === "arabic"
                                      ? "المبلغ بالأحرف:"
                                      : "Amount In Words:"}
                                    &nbsp;
                                    {AmountInWords(Details?.overall_price)}
                                  </strong>
                                </p>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="row border-top border-bottom py-3 mx-3">
                    <div className="col-10 col-md-4 d-flex">
                      <div
                        className="p-2 flex-fill d-flex flex-column"
                        style={{ border: ".8px solid #dee2e6" }}
                      >
                        <h6 className="fw-bold">
                          {selectedLanguage === "arabic"
                            ? "الشروط والأحكام"
                            : "Terms & Condition:"}
                        </h6>
                        <p className="mt-2 fs-8 flex-grow-1" style={{ whiteSpace: 'pre-wrap' }}>
                          {RemarkData?.terms}
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-md-4 d-flex">
                      <div
                        className="p-2 flex-fill d-flex flex-column"
                        style={{ border: ".8px solid #dee2e6" }}
                      >
                        <h6 className="fw-bold">
                          {selectedLanguage === "arabic"
                            ? "حساب البنك"
                            : "Bank Account:"}
                        </h6>
                        <p className="mt-2  fs-6 flex-grow-1">
                          <p className="">Name:{data?.bank_name || "N/A"}</p>
                          Bank:{data?.bank_branch || "N/A"}
                          <br />
                          {data?.account_no
                            ? `A/C No: ${data.account_no}`
                            : "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-md-4 d-flex">
                      <div
                        className="p-2 flex-fill d-flex flex-column"
                        style={{ border: ".8px solid #dee2e6" }}
                      >
                        <h6 className="fw-bold">
                          {selectedLanguage === "arabic"
                            ? "لشركة توب تكنو"
                            : "For Top Tecno:"}
                        </h6>
                        <p className="mt-2  fs-6 flex-grow-1">
                          {data?.shop_title || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="modal-footer mx-1 mt-4">
                <button
                  type="button"
                  className={"btn btn-info " + printVisible}
                  onClick={() => {
                    printerType == "0" ? handlePrint() : handlePrint1();
                  }}
                >
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade show"
          style={{ display: pamentsModel ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content p-3"
              style={{
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* Modal Header */}
              <div className="modal-header border-0">
                <h5 className="modal-title fw-bold text-dark font-18">
                  Payment
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setpamentsModel(false)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div className="p-3 bg-light rounded ">
                  <p className="mb-2 text-start">
                    Sales ID:{" "}
                    <span className="fw-bold">{Paymentvalue?.order_id}</span>
                  </p>
                  <p className="mb-2 text-start">
                    <span>Customer Name:</span>
                    <span className="fw-bold">
                      {Paymentvalue?.customer_name}
                    </span>
                  </p>
                  <hr />
                  <div>
                    <p className="mb-2 d-flex justify-content-between">
                      <span>Amount:</span>
                      <span className="text-primary fw-bold">
                        {Paymentvalue?.overall_price}
                      </span>
                    </p>
                    <p className="mb-2 d-flex justify-content-between">
                      <span>Due Amount:</span>
                      <span className="text-danger fw-bold">
                        {Paymentvalue?.remaining || "00"}
                      </span>
                    </p>
                    <p className="mb-2 d-flex justify-content-between align-items-center">
                      <span>Cash:</span>
                      <input
                        type="number"
                        className="form-control text-end w-25"
                        value={cashAmount}
                        onChange={(e) => handleCashChange(e)}
                      />
                    </p>
                    <p className="mb-2 d-flex justify-content-between align-items-center">
                      <span>Card:</span>
                      <input
                        type="number"
                        className="form-control text-end w-25"
                        value={cardAmount}
                        onChange={(e) => handleCardChange(e)}
                      />
                    </p>
                  </div>
                  <hr />
                  <p className="mb-0 fw-bold fs-5 text-end">
                    Remaining Amount:
                    <span className="text-success fw-bold">
                      {remainingAmount.toFixed(3)}
                    </span>
                  </p>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer border-0 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={() => setpamentsModel(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success"
                  disabled={
                    totalPayment <= 0 ||
                    totalPayment > parseFloat(Paymentvalue?.remaining || 0)
                  }
                  onClick={() => onHandlePayCredit(cashAmount, cardAmount)}
                >
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>

        <OrderDetailsModal
          orders={selectedOrder}
          orderItems={orderItems}
          setSelectedOrder={setSelectedOrder}
          selectedOrder={selectedOrderData}
          isOpen={isOrderModal}
          onClose={() => setOrderModal(false)}
          handleGet={handleGet}
        />

        {/* ── SALES RETURN MODAL ─────────────────────────────────── */}
        {showReturnModal && (() => {
          const fin = calcReturnFinancials();
          return (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div className="modal-content" style={{ borderRadius: "14px", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>

                  {/* Header */}
                  <div className="modal-header" style={{ background: "linear-gradient(135deg, #dc3545 0%, #b02a37 100%)", borderRadius: "14px 14px 0 0" }}>
                    <div>
                      <h5 className="modal-title text-white fw-bold mb-0">
                        🔄 Process Sales Return
                      </h5>
                      <small className="text-white opacity-75">
                        Order: {returnOrder?.order_id} &nbsp;|&nbsp; Customer: {returnOrder?.customer_name}
                      </small>
                    </div>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowReturnModal(false)} />
                  </div>

                  {/* Body */}
                  <div className="modal-body p-4">

                    {/* Order Items Table */}
                    <h6 className="fw-bold mb-3 text-dark">Select Items to Return</h6>
                    {returnItems.length === 0 ? (
                      <div className="text-center text-muted py-4">No items found for this order.</div>
                    ) : (
                      <div className="table-responsive mb-4">
                        <table className="table table-bordered table-sm align-middle">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Product</th>
                              <th className="text-center">Sold Qty</th>
                              <th className="text-center text-danger">Returned Qty</th>
                              <th className="text-center">Unit Price</th>
                              <th className="text-center">Return Qty</th>
                              <th className="text-end">Return Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {returnItems.map((it, idx) => {
                              const alreadyRet = alreadyReturnedQtys[it.id] || 0;
                              const soldQty = parseFloat(it.qty || 0) + alreadyRet;
                              const remainingQty = parseFloat(it.qty || 0);
                              const retQty = returnQtys[it.id] || 0;
                              const unitPrice = getUnitPrice(it);
                              const retAmt = retQty * unitPrice;
                              return (
                                <tr key={it.id} className={retQty > 0 ? "table-danger" : ""}>
                                  <td>{idx + 1}</td>
                                  <td>
                                    <div className="fw-semibold">{it.product_title || it.product_name || `Product #${it.p_id}`}</div>
                                    {it.batch_no && <small className="text-muted">Batch: {it.batch_no}</small>}
                                  </td>
                                  <td className="text-center">{soldQty}</td>
                                  <td className="text-center text-danger fw-semibold">{alreadyRet > 0 ? alreadyRet : "—"}</td>
                                  <td className="text-center">₹{unitPrice.toFixed(2)}</td>
                                  <td className="text-center" style={{ width: "130px" }}>
                                    {remainingQty <= 0 ? (
                                      <span className="badge bg-danger">Fully Returned</span>
                                    ) : (
                                      <div className="d-flex align-items-center gap-1 justify-content-center">
                                        <button
                                          className="btn btn-outline-secondary btn-sm px-2 py-0"
                                          onClick={() => handleReturnQtyChange(it.id, (retQty - 1).toString(), remainingQty)}
                                        >−</button>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm qty-input-no-spin"
                                          value={retQty}
                                          min={0}
                                          max={remainingQty}
                                          onChange={(e) => handleReturnQtyChange(it.id, e.target.value, remainingQty)}
                                        />
                                        <button
                                          className="btn btn-outline-secondary btn-sm px-2 py-0"
                                          onClick={() => handleReturnQtyChange(it.id, (retQty + 1).toString(), remainingQty)}
                                        >+</button>
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-end fw-semibold">
                                    {retQty > 0 ? `₹${retAmt.toFixed(2)}` : "—"}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Financial Summary */}
                    <div className="card border-0 mb-3" style={{ background: "#f8f9fa" }}>
                      <div className="card-body p-3">
                        <h6 className="fw-bold mb-3" style={{ color: "#dc3545" }}>Financial Summary</h6>
                        <div className="row g-2">
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Total Return Value</span>
                              <span className="fw-bold">₹{fin.totalReturn.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Customer Credit Balance</span>
                              <span className="fw-bold text-info">₹{Math.max(0, parseFloat(returnOrder?.remaining || 0) - getOrderReturnedAmount(returnOrder?.order_id, returnOrder?.id)).toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Credit Adjusted</span>
                              <span className="fw-bold text-warning">−₹{fin.creditAdjust.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between border-bottom pb-2">
                              <span className="text-muted small">Refund Amount</span>
                              <span className="fw-bold text-success">₹{fin.refundAmount.toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between">
                              <span className="text-muted small">New Credit Balance</span>
                              <span className="fw-bold text-primary">₹{fin.newCredit.toFixed(2)}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Refund Type Toggle */}
                    {fin.refundAmount > 0 && (
                      <div className="mb-3">
                        <label className="fw-semibold mb-2 d-block">How to handle ₹{fin.refundAmount.toFixed(2)} refund?</label>
                        <div className="d-flex gap-3">
                          <div
                            className={`flex-fill p-3 rounded border-2 cursor-pointer ${returnRefundType === "bank" ? "border border-danger bg-danger bg-opacity-10" : "border"}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setReturnRefundType("bank")}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <input type="radio" checked={returnRefundType === "bank"} onChange={() => setReturnRefundType("bank")} />
                              <div>
                                <div className="fw-bold small">Refund to Bank</div>
                                <div className="text-muted" style={{ fontSize: "11px" }}>Cash paid back to customer now</div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`flex-fill p-3 rounded border-2 cursor-pointer ${returnRefundType === "payable" ? "border border-primary bg-primary bg-opacity-10" : "border"}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setReturnRefundType("payable")}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <input type="radio" checked={returnRefundType === "payable"} onChange={() => setReturnRefundType("payable")} />
                              <div>
                                <div className="fw-bold small">Keep as Customer Payable</div>
                                <div className="text-muted" style={{ fontSize: "11px" }}>Reduce on next sale or pay later</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Return Reason */}
                    <div className="mb-2">
                      <label className="fw-semibold mb-1 small">Return Reason <span className="text-muted">(optional)</span></label>
                      <textarea
                        className="form-control form-control-sm"
                        rows={2}
                        placeholder="e.g. Damaged product, Wrong item..."
                        value={returnReason}
                        onChange={(e) => setReturnReason(e.target.value)}
                      />
                    </div>

                    {/* Return Invoice # */}
                    <div className="text-muted small">
                      Return Invoice#: <strong>{returnInvoiceNo}</strong>
                    </div>

                  </div>

                  {/* Footer */}
                  <div className="modal-footer border-0 pt-0">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowReturnModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-danger fw-bold"
                      onClick={handleSubmitReturn}
                      disabled={fin.totalReturn === 0}
                    >
                      Confirm Return — ₹{fin.totalReturn.toFixed(2)}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          );
        })()}
        {/* ─────────────────────────────────────────────────────────── */}

      </div>
    </div>
  );
};

const OrderDetailsModal = ({
  orders,
  orderItems,
  isOpen,
  onClose,
  setSelectedOrder,
  handleGet,
  selectedOrder,
}) => {
  console.log("orders", orders);
  console.log("selectedorder", selectedOrder);
  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      style={{ display: isOpen ? "block" : "none" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div
          className="modal-content p-3"
          style={{
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Modal Header */}
          <div className="modal-header border-0">
            <h5 className="modal-title fw-bold text-dark font-18">
              Payment Details
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>

          {/* Modal Body */}
          <div className="modal-body pt-0">
            {selectedOrder && (
              <div className="mt-3">
                <table className="table table-bordered table-striped shadow-sm">
                  <thead className="table-primary">
                    <tr>
                      <th colSpan="4">
                        <div className="justify-content-between d-flex">
                          <span>Order Details</span>
                          <a
                            className="bg-gradient-blues rounded px-2 font-13 text-black pointer"
                            onClick={() => {
                              onClose();
                              setSelectedOrder(orders);
                              handleGet(selectedOrder);
                            }}
                          >
                            Invoice
                          </a>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fw-bold">Sales ID</td>
                      <td>{selectedOrder.order_id}</td>

                      <td className="fw-bold">Customer Name</td>
                      <td>{selectedOrder.customer_name}</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Date</td>
                      <td>{selectedOrder.create_date.split('T')[0]}</td>

                      <td className="fw-bold">Total Amount</td>
                      <td>{selectedOrder.overall_price}</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Intial Amount</td>
                      <td>{selectedOrder.amount}</td>
                      <td className="fw-bold">Remaining Amount</td>
                      <td>{selectedOrder.remaining}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {/* Order Items */}
            <h6 className="modal-title fw-bold text-dark mt-3">Order Items</h6>
            <div className="table-responsive my-1 w-100">
              <table className="table table-sm table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {orderItems && orderItems.length > 0 ? (
                    orderItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="fw-semibold">
                          {item.product_title || `Product #${item.p_id}`}
                          {item.p_weight && item.pbox_unit ? (
                            <span className="text-muted ms-1" style={{ fontSize: "0.8rem" }}>
                              ({item.p_weight} {item.pbox_unit})
                            </span>
                          ) : null}
                        </td>
                        <td>{item.qty}</td>
                        <td>₹{item.is_free === "1" ? "0.00" : (parseFloat(item.p_price || 0) / parseFloat(item.qty || 1)).toFixed(2)}</td>
                        <td className="fw-semibold">
                          {item.is_free === "1" ? (
                            <span className="text-success">Free</span>
                          ) : (
                            `₹${parseFloat(item.p_price || 0).toFixed(2)}`
                          )}
                        </td>
                        <td>
                          <span className={`badge ${item.is_free === "1" ? "bg-success" : "bg-primary"}`}>
                            {item.is_free === "1" ? "Offer" : "Normal"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center text-muted">No items found</td>
                    </tr>
                  )}
                </tbody>
                {orderItems && orderItems.length > 0 && (
                  <tfoot>
                    <tr>
                      <td colSpan="4" className="text-end fw-bold">Grand Total:</td>
                      <td className="fw-bold">
                        ₹{orderItems
                          .filter(i => i.is_free !== "1")
                          .reduce((sum, i) => sum + parseFloat(i.p_price || 0), 0)
                          .toFixed(2)}
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>

            {/* Order List */}
            <h6 className="modal-title fw-bold text-dark">Payment History</h6>
            <div className="table-responsive text-center my-1 w-100 position-relative">
              <table className="table table-striped table-sm table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>MOP</th>
                    <th>Amount (INR)</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {orders
                    .filter((item) => item.mop != "2")
                    .map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.date}</td>
                        <td>
                          {item.mop == "1"
                            ? "Cash"
                            : item.mop == "4"
                              ? "Card"
                              : ""}
                        </td>
                        <td>{item.amount}</td>
                        <td>
                          <img
                            src="/assets/images/icons/view.png"
                            onClick={() => {
                              setSelectedOrder(
                                orders
                                  .filter((item) => item.mop != "2")
                                  .slice(0, index + 1)
                              );
                              onClose();
                              handleGet(selectedOrder);
                            }}
                            height={"20px"}
                            alt="view"
                            className="me-2"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="modal-footer border-0 d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesList;
